import { motion } from "framer-motion";
import { HtmlContent } from "../../../../common/components/HtmlContent";
import { replaceNonBreakingSpaces } from "../../utils";

interface AnnouncementBannerProps {
    title: string;
    description: string;
    onClose: () => void;
}

const AnnouncementBanner = (props: AnnouncementBannerProps) => {
    const { title, description, onClose } = props;

    return (
        <motion.div
            initial={{ height: 0, opacity: 0 }}
            animate={{ height: "auto", opacity: 1 }}
            exit={{ height: 0, opacity: 0 }}
            transition={{ duration: 0.3, ease: "easeInOut" }}
            className="relative z-30000 shrink-0 overflow-hidden"
        >
            <div className="flex items-center border-b border-primary-500 bg-primary-50 px-6 py-2.5">
                <div className="flex flex-1 min-w-0 items-center justify-center">
                    <span className="flex min-w-0 flex-col items-center text-primary-750 md:flex-row md:items-start">
                        <span className="flex shrink-0 items-center gap-1.5 font-bold whitespace-nowrap">
                            <i className="pi pi-info-circle" />
                            {title}
                        </span>
                        {description && (
                            <HtmlContent
                                html={replaceNonBreakingSpaces(description)}
                                className="min-w-0 text-center md:ml-1.5 md:text-left [&_p]:inline"
                            />
                        )}
                    </span>
                </div>
                <button
                    className="shrink-0 py-1 px-3.5 -mr-3.5 text-primary-750 hover:text-primary-500 transition-colors"
                    onClick={onClose}
                >
                    <i className="pi pi-times text-sm" />
                </button>
            </div>
        </motion.div>
    );
};

export default AnnouncementBanner;
